import React from "react"
import {
  Flex,
  Text,
  Box,
  MenuItem,
  Menu,
  MenuButton,
  MenuList,
} from "@chakra-ui/react"
import type { ExperimentPreviewContextType } from "components/Experiments/ExperimentPreviewProvider/ExperimentPreviewProvider"
import { ChevronDownIcon } from "@chakra-ui/icons"
import { useSearchParams } from "next/navigation"
import { Link } from "components/Link"

interface Props {
  variants?: ExperimentPreviewContextType
}

export const ExperimentVariantSelect: React.FC<Props> = ({ variants }) => {
  const currentPageParams = useSearchParams()
  const selectedVariantIndex = Number(currentPageParams?.get("selectedVariant"))
  const selectedVariant = variants?.[selectedVariantIndex] ?? variants?.[0]

  const searchParams = new URLSearchParams()

  return (
    <Box mx={3} mb={1} data-testid="page-variant-select">
      <Flex justifyContent="center">
        <Text fontWeight="bold" textAlign="center">
          Choose page variant:&nbsp;
        </Text>
        <Menu>
          <MenuButton>
            <Text data-testid="current-page-variant" textAlign="center">
              {selectedVariant ?? "Select a page variant to preview"}
              <ChevronDownIcon />
            </Text>
          </MenuButton>
          <MenuList>
            {variants?.map((label, value) => {
              searchParams.set("selectedVariant", value.toString())
              return (
                <MenuItem
                  key={label}
                  as={Link}
                  href={`?${searchParams.toString()}`}
                >
                  {label}
                </MenuItem>
              )
            })}
          </MenuList>
        </Menu>
      </Flex>
    </Box>
  )
}
